import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid, Divider } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';

export const FolderSummaryComponent = ({ folderSummary, t }) => {
  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <Typography fontWeight='bold' variant='subtitle1' textTransform='uppercase' gutterBottom>
          {t('Folder.Summary.Title')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} sm={6}>
        {t('Folder.Summary.Price')}
      </Grid>
      <Grid item xs={12} sm={6} textAlign='end'>
        <span>
          {''} {t('DECIMAL', { number: folderSummary.assetsAmount })}
        </span>
      </Grid>
      <Grid item xs={12} sm={6}>
        {t('Folder.Summary.FinancedAmount')}
      </Grid>
      <Grid item xs={12} sm={6} textAlign='end'>
        <span>
          {''} {t('DECIMAL', { number: folderSummary.financedAmount })}
        </span>
      </Grid>
      <Grid item xs={12} sm={6}>
        {t('Folder.Summary.ExistingExposure')}
      </Grid>
      <Grid item xs={12} sm={6} textAlign='end'>
        <span>
          {''} {t('DECIMAL', { number: folderSummary.existingExposure })}
        </span>
      </Grid>
      <Grid item xs={12} sm={6}>
        {t('Folder.Summary.NewExposure')}
      </Grid>
      <Grid item xs={12} sm={6} textAlign='end'>
        <span>
          {''} {t('DECIMAL', { number: folderSummary.newExposure })}
        </span>
      </Grid>
      <Grid item xs={12} sm={6}>
        {t('Folder.Summary.ScoringResult')}
      </Grid>
      <Grid item xs={12} sm={6} textAlign='end'>
        <span>{folderSummary.scoringResult}</span>
      </Grid>
    </Grid>
  );
};

FolderSummaryComponent.propTypes = {
  folderSummary: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export default compose(withTranslation())(FolderSummaryComponent);
